/* FUSFIT POINTS en la tienda (borrador 22-oct-2026). Lo carga snippets/ff-puntos-datos.liquid SOLO si se ven los
   bloques (snippets/ff-puntos-visible: programa en «vivo» o contacto de prueba con sesión). Pinta, en los sitios que
   deja el Liquid (cada uno también detrás de ff-puntos-visible):
   - [data-ff-pts="ficha"]    debajo del precio: «Suma N FUSFIT POINTS con este producto» y la barra al siguiente canje;
   - [data-ff-pts="cabecera"] la pastilla «★ 340 pts» junto a la cuenta y su panel;
   - [data-ff-pts="carrito"]  en el resumen: «+N FUSFIT POINTS con este pedido» y un botón por canje que alcanza;
   - [data-ff-pts="mis-puntos"] el panel personal de /pages/fusfit-points;
   - [data-ff-pts="landing"]  la landing pública de /pages/fusfit-points.
   Todas las cifras salen de los metacampos del ERP (#ff-pts-datos). N se calcula como el motor (estimado-pura.ts del ERP:
   centavos × compra × multiplicador, hacia abajo; multiplicador = evento vigente en Caracas + extra por monto). La base
   es el precio NORMAL (en Bs, antes del descuento de divisas) que la plantilla YA calculó, para cualquier forma de pago
   (decisión del dueño, 22-oct; así lo cuenta el ERP). Ningún factor de divisas propio.
   Los canjes van por el proxy firmado (/apps/storefront-control/puntos). Nunca se dice que algo se
   pierde ni se muestran cantidades de productos. */
(() => {
  if (window.ffPuntos) return;
  const PROXY = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'apps/storefront-control/puntos';
  const CLAVE_SALDO = 'ff_pts_saldo_v1';
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
  const miles = (n) => Math.trunc(Number(n) || 0).toLocaleString('es-VE');
  const dolares = (n) => '$' + (Number(n) % 1 ? Number(n).toFixed(2) : String(Number(n)));
  const minuscula = (s) => { s = String(s || ''); return s.charAt(0).toLowerCase() + s.slice(1); };

  let D = null;
  try { D = JSON.parse(document.getElementById('ff-pts-datos').textContent); } catch (_) { return; }
  if (!D) return;
  const R = D.reglas && typeof D.reglas === 'object' ? D.reglas : null;
  const recompensas = () => (R && Array.isArray(R.recompensas) ? [...R.recompensas].sort((a, b) => a.costo - b.costo) : []);
  const niveles = () => (R && Array.isArray(R.niveles) ? [...R.niveles].sort((a, b) => a.desde - b.desde) : []);

  // Saldo: el del metacampo, salvo que en esta sesión se haya canjeado algo (el ERP reescribe el metacampo después).
  function saldo() {
    let s = Number(D.saldo) || 0;
    try { const o = JSON.parse(sessionStorage.getItem(CLAVE_SALDO) || 'null'); if (o && Date.now() - o.t < 30 * 60000 && o.saldo < s) s = o.saldo; } catch (_) {}
    return s;
  }
  function guardarSaldo(s) { try { sessionStorage.setItem(CLAVE_SALDO, JSON.stringify({ saldo: s, t: Date.now() })); } catch (_) {} }

  // ── Cálculo (mismo que estimado-pura.ts del ERP) ──
  // La cuenta está en assets/ff-puntos-calculo.js (compartida con la escalera y probada contra estimado-pura.ts del ERP).
  const C = window.ffPuntosCalculo;
  if (!C) return;
  const porMonto = () => C.porMontoVigente(R);
  const estimar = (baseCents, dudaCents) => C.estimar(baseCents, R, Date.now(), dudaCents);
  const baseDe = (el) => Number(el.dataset.baseCents) || 0;

  // «Te faltan N FUSFIT POINTS para tu …» (misma frase que textoFaltan del ERP).
  const textoFaltan = (s, r) => (r.costo - s > 0 ? `Te faltan ${miles(r.costo - s)} FUSFIT POINTS para tu ${minuscula(r.nombre)}.` : `Ya te alcanza para tu ${minuscula(r.nombre)}.`);
  const mejorAlcanzable = (s) => recompensas().filter((r) => r.costo <= s).pop() || null;
  const siguienteCanje = (s) => recompensas().find((r) => r.costo > s) || null;
  function nivelDe(g) {
    const ns = niveles(); let actual = ns[0] || null, sig = null;
    for (const n of ns) { if (g >= n.desde) actual = n; else { sig = n; break; } }
    return { actual: (D.nivel || (actual && actual.nombre) || ''), sig };
  }

  function lineaMult(x, donde) {
    const partes = [];
    if (x.evento.m > 1) partes.push(x.evento.fusfitDay ? 'Hoy es FUSFIT Day' : 'Hoy tus puntos valen más');
    if (x.llega) partes.push(`${donde === 'ficha' ? 'Compra' : 'Pedido'} de ${dolares(x.pm.desde)} o más`);
    return partes.length ? `<span class="ff-pts__mult">×${x.m}</span> ${esc(partes.join(' · '))}` : '';
  }
  // Solo en la ficha (en el carrito ya lo dice la escalera): cuánto valen los puntos desde el monto de la regla.
  const notaMonto = (x) => (x.pm && !x.llega ? `<p class="ff-pts__nota">Con compras desde ${esc(dolares(x.pm.desde))} tus puntos valen ×${esc(x.evento.m + x.pm.extra)}.</p>` : '');

  // ── Ficha ──
  function ficha(el) {
    if (!R) { el.hidden = true; return; }
    const x = estimar(baseDe(el));
    if (!(x.n > 0)) { el.hidden = true; return; }
    let extra = '';
    if (D.sesion) {
      const s = saldo(), meta = siguienteCanje(s), llega = s + x.n;
      if (meta) {
        const pct = Math.min(100, (s / meta.costo) * 100), pctN = Math.min(100 - pct, (x.n / meta.costo) * 100);
        const txt = llega >= meta.costo ? `Tienes ${miles(s)}. Con este producto llegas a ${miles(llega)}: tu ${minuscula(meta.nombre)}.`
          : `Tienes ${miles(s)}. Con este producto llegas a ${miles(llega)}. ${textoFaltan(llega, meta)}`;
        extra = `<div class="ff-pts__barra" role="img" aria-label="${esc(txt)}"><i style="width:${pct.toFixed(1)}%"></i><i class="is-nuevo" style="width:${pctN.toFixed(1)}%"></i></div><p class="ff-pts__sub">${esc(txt)}</p>`;
      } else {
        const r = mejorAlcanzable(s);
        if (r) extra = `<p class="ff-pts__sub">Tienes ${miles(s)}: ${esc(textoFaltan(s, r))}</p>`;
      }
      // Algo donde tocar para canjear (pedido del dueño, 23-oct): la página FUSFIT POINTS tiene los botones de canje.
      extra += mejorAlcanzable(s)
        ? `<p class="ff-pts__acc"><a class="ff-pts__btn" href="${esc(D.urls.landing)}#ff-mis-puntos">Canjear mis puntos</a></p>`
        : `<p class="ff-pts__sub"><a href="${esc(D.urls.landing)}#ff-mis-puntos">Ver mis puntos y canjes</a></p>`;
    } else if (Number(R.ganar && R.ganar.registro) > 0) {
      extra = `<p class="ff-pts__sub"><a href="${esc(D.urls.registro)}">Crea tu cuenta y te regalamos ${miles(R.ganar.registro)} puntos</a></p>`;
    }
    const lm = lineaMult(x, 'ficha');
    el.hidden = false;
    el.innerHTML = `<p class="ff-pts__tit"><span class="ff-pts__estrella" aria-hidden="true">★</span>Suma <b>${miles(x.n)}</b> FUSFIT POINTS con este producto</p>
      ${lm ? `<p class="ff-pts__sub">${lm}</p>` : ''}${extra}${notaMonto(x)}`;
  }

  // ── Cabecera ──
  function cabecera(el) {
    if (!D.sesion) { el.remove(); return; }
    colocarPastilla(el);
    const s = saldo(), g = Number(D.ganados) || 0, nv = nivelDe(g), sig = (D.resumen && D.resumen.siguiente) || (nv.sig && { nombre: nv.sig.nombre, desde: nv.sig.desde, faltan: nv.sig.desde - g });
    const pct = sig && sig.desde > 0 ? Math.max(0, Math.min(100, (g / sig.desde) * 100)) : 100;
    const r = mejorAlcanzable(s), meta = siguienteCanje(s);
    el.innerHTML = `<button type="button" class="ff-pts-cab__pastilla" aria-expanded="false" aria-controls="ff-pts-panel">
        <span aria-hidden="true">★</span> ${miles(s)} <small>pts</small><span class="ff-pts__sr"> FUSFIT POINTS: ver tu saldo</span></button>`;
    // El panel va colgado de <body> (fijo): así no lo recorta la fila de chips ni la cabecera fija del tema.
    document.getElementById('ff-pts-panel')?.remove();
    const panel = document.createElement('div');
    panel.className = 'ff-pts ff-pts-cab__panel'; panel.id = 'ff-pts-panel'; panel.hidden = true;
    panel.innerHTML = `
        <p class="ff-pts-cab__marca">FUSFIT <b>POINTS</b></p>
        <p class="ff-pts-cab__saldo"><b>${miles(s)}</b> puntos${nv.actual ? ` · Nivel ${esc(nv.actual)}` : ''}</p>
        ${sig ? `<div class="ff-pts__barra" role="img" aria-label="${miles(g)} de ${miles(sig.desde)} para ${esc(sig.nombre)}"><i style="width:${pct.toFixed(1)}%"></i></div>
          <p class="ff-pts__sub">Te faltan ${miles(Math.max(0, sig.faltan ?? sig.desde - g))} puntos para ${esc(sig.nombre)}.</p>` : ''}
        ${r ? `<p class="ff-pts__sub ff-pts__ok">${esc(textoFaltan(s, r))}</p>` : meta ? `<p class="ff-pts__sub">${esc(textoFaltan(s, meta))}</p>` : ''}
        <p class="ff-pts__sub">Tus puntos no se pierden.</p>
        <a class="ff-pts__btn" href="${esc(D.urls.landing)}">Ver mis puntos</a>`;
    document.body.appendChild(panel);
  }
  // Computadora: junto al ícono de la cuenta (header-actions). Teléfono: primera de la fila de chips (al lado de la
  // cuenta no cabe sin tapar el logo). Se vuelve a colocar al cambiar el ancho.
  const esMovil = () => window.matchMedia('(max-width: 989px)').matches;
  function colocarPastilla(el) {
    const destino = esMovil() ? document.querySelector('.ff-chips') : document.querySelector('header-actions');
    if (destino && el.parentElement !== destino) destino.insertBefore(el, destino.firstElementChild);
  }
  window.addEventListener('resize', () => { const el = document.querySelector('[data-ff-pts="cabecera"]'); if (el) colocarPastilla(el); alternarPanel(false); });
  window.addEventListener('scroll', () => alternarPanel(false), { passive: true });
  function alternarPanel(abrir) {
    const b = document.querySelector('.ff-pts-cab__pastilla'), p = document.getElementById('ff-pts-panel');
    if (!b || !p) return;
    const ab = abrir ?? p.hidden;
    if (ab) {
      const r = b.getBoundingClientRect();
      p.style.top = Math.round(r.bottom + 8) + 'px';
      if (esMovil()) { p.style.left = '16px'; p.style.right = '16px'; }
      else { p.style.left = 'auto'; p.style.right = Math.max(16, Math.round(innerWidth - r.right)) + 'px'; }
    }
    p.hidden = !ab; b.setAttribute('aria-expanded', String(ab));
  }

  // ── Canje (carrito y panel personal) ──
  async function tokenCarrito() { const r = await fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', { headers: { Accept: 'application/json' } }); return (await r.json()).token; }
  async function canjear(recompensaId) {
    const carrito = await tokenCarrito();
    const r = await fetch(PROXY + '?accion=canjear', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ recompensaId, carrito }) });
    const j = await r.json().catch(() => null);
    if (!j) throw new Error('No se pudo canjear. Inténtalo de nuevo.');
    if (j.ok && j.activo === false) throw new Error('Tus FUSFIT POINTS todavía no están disponibles en la tienda.');
    if (!j.ok || !j.codigo) throw new Error(j.error || 'No se pudo canjear. Inténtalo de nuevo.');
    if (Number.isFinite(j.saldoDespues)) guardarSaldo(j.saldoDespues);
    return j;
  }

  // ── Carrito ──
  function carrito(el) {
    if (!R) { el.hidden = true; return; }
    const x = estimar(baseDe(el), Number(el.dataset.dudaCents) || 0);
    const s = D.sesion ? saldo() : 0;
    const usables = D.sesion ? recompensas().filter((r) => r.costo <= s) : [];
    if (!(x.n > 0) && !usables.length) { el.hidden = true; return; }
    const lm = lineaMult(x, 'carrito');
    el.hidden = false;
    el.innerHTML = `${x.n > 0 ? `<p class="ff-pts__tit"><span class="ff-pts__estrella" aria-hidden="true">★</span><b>+${miles(x.n)}</b> FUSFIT POINTS con este pedido</p>` : ''}
      ${lm ? `<p class="ff-pts__sub">${lm}</p>` : ''}
      ${D.sesion ? `<p class="ff-pts__sub">Tienes ${miles(s)} FUSFIT POINTS.</p>` : `<p class="ff-pts__sub"><a href="${esc(D.urls.entrar)}">Inicia sesión</a> para usar tus puntos.</p>`}
      ${usables.length ? `<div class="ff-pts__canjes">${usables.map((r) => `<button type="button" class="ff-pts__btn ff-pts__btn--canje" data-ff-pts-canjear="${Number(r.id)}">Usar ${miles(r.costo)}: ${esc(minuscula(r.nombre))}</button>`).join('')}</div>` : ''}
      <p class="ff-pts__msg" role="status" hidden></p>`;
  }

  // ── Panel personal «Mis FUSFIT POINTS» (/pages/fusfit-points) ──
  function misPuntos(el) {
    if (!D.sesion) {
      el.innerHTML = `<div class="ff-pts-mp__caja"><h2 class="ff-pts-h">Tus FUSFIT POINTS</h2><p>Entra o crea tu cuenta para ver tu saldo y canjear tus puntos.</p>
        <a class="ff-pts__btn" href="${esc(D.urls.registro)}">Crear mi cuenta</a> <a class="ff-pts__btn ff-pts__btn--sec" href="${esc(D.urls.entrar)}">Iniciar sesión</a></div>`;
      return;
    }
    const s = saldo(), g = Number(D.ganados) || 0, nv = nivelDe(g);
    const sig = (D.resumen && D.resumen.siguiente) || (nv.sig && { nombre: nv.sig.nombre, desde: nv.sig.desde, faltan: nv.sig.desde - g });
    const pct = sig && sig.desde > 0 ? Math.max(0, Math.min(100, (g / sig.desde) * 100)) : 100;
    const hist = (D.resumen && Array.isArray(D.resumen.historial) ? D.resumen.historial : []).slice(0, 20);
    const cods = D.resumen && Array.isArray(D.resumen.codigos) ? D.resumen.codigos : [];
    const enlace = D.codigoRef ? 'https://fusfit.com/?ffref=' + encodeURIComponent(D.codigoRef) : '';
    const pctAmigo = Number(R && R.recomendadoPct) || 0, ptsRecomendar = Number(R && R.ganar && R.ganar.recomendar) || 0;
    const ptsCumple = Number(R && R.ganar && R.ganar.cumpleanos) || 0, compra = Number(R && R.ganar && R.ganar.compra) || 0;
    el.innerHTML = `
      <div class="ff-pts-mp__caja ff-pts-mp__saldo">
        <h2 class="ff-pts-h">Hola${D.nombre ? ', ' + esc(D.nombre) : ''}</h2>
        <p class="ff-pts-mp__cifra"><b>${miles(s)}</b> FUSFIT POINTS${nv.actual ? ` <span class="ff-pts-mp__nivel">Nivel ${esc(nv.actual)}</span>` : ''}</p>
        ${sig ? `<div class="ff-pts__barra" role="img" aria-label="${miles(g)} de ${miles(sig.desde)} para ${esc(sig.nombre)}"><i style="width:${pct.toFixed(1)}%"></i></div>
          <p class="ff-pts__sub">Llevas ${miles(g)} puntos ganados. Te faltan ${miles(Math.max(0, sig.faltan ?? sig.desde - g))} para ${esc(sig.nombre)}.</p>` : ''}
        <p class="ff-pts__sub"><b>Tus puntos no se pierden.</b> <a href="${esc(D.urls.cuenta)}">Ver en mi cuenta</a></p>
      </div>
      ${recompensas().length ? `<div class="ff-pts-mp__caja"><h2 class="ff-pts-h">Canjea</h2>
        ${recompensas().map((r) => `<div class="ff-pts-mp__fila"><span>${esc(r.nombre)} <span class="ff-pts-mp__chip">${miles(r.costo)} puntos</span></span>
          ${r.costo <= s ? `<button type="button" class="ff-pts__btn" data-ff-pts-canjear="${Number(r.id)}">Canjear</button>` : `<span class="ff-pts__sub">${esc(textoFaltan(s, r))}</span>`}</div>`).join('')}
        <p class="ff-pts__msg" role="status" hidden></p>
        <p class="ff-pts__sub">Al canjear te damos un código de un solo uso. Cópialo o úsalo en tu carrito.</p></div>` : ''}
      ${cods.length ? `<div class="ff-pts-mp__caja"><h2 class="ff-pts-h">Tus códigos</h2>${cods.map((c) => `<div class="ff-pts-mp__fila"><span><code>${esc(c.codigo)}</code> · ${esc(c.nombre)}</span>
        <button type="button" class="ff-pts__btn ff-pts__btn--sec" data-ff-pts-copiar="${esc(c.codigo)}">Copiar</button></div>`).join('')}</div>` : ''}
      <div class="ff-pts-mp__caja"><h2 class="ff-pts-h">Gana más</h2>
        ${compra > 0 ? `<p class="ff-pts__sub"><b>${miles(compra)} por cada $1</b> en cada compra, por cualquier canal.</p>` : ''}
        ${enlace && ptsRecomendar > 0 ? `<div class="ff-pts-mp__ref"><p><b>Recomienda y gana ${miles(ptsRecomendar)}.</b> ${pctAmigo ? `Tú y tu amigo ganan: él tiene ${pctAmigo} % en su primera compra y tú sumas ${miles(ptsRecomendar)} puntos cuando la pague.` : ''}</p>
          <div class="ff-pts-mp__fila"><code class="ff-pts-mp__enlace">${esc(enlace)}</code><button type="button" class="ff-pts__btn ff-pts__btn--sec" data-ff-pts-copiar="${esc(enlace)}">Copiar enlace</button></div></div>` : ''}
        ${!D.cumpleanosFijado && ptsCumple > 0 ? `<form class="ff-pts-mp__cumple" data-ff-pts-cumple><label for="ff-pts-fecha"><b>Tu cumpleaños:</b> te regalamos ${miles(ptsCumple)} puntos ese día. Solo se guarda una vez.</label>
          <div class="ff-pts-mp__fila"><input type="date" id="ff-pts-fecha" name="fecha" required max="${new Date(Date.now() - 4 * 3600000).toISOString().slice(0, 10)}"><button type="submit" class="ff-pts__btn">Guardar</button></div>
          <p class="ff-pts__msg" role="status" hidden></p></form>` : ''}
      </div>
      ${hist.length ? `<div class="ff-pts-mp__caja"><h2 class="ff-pts-h">Últimos movimientos</h2>${hist.map((h) => `<div class="ff-pts-mp__fila"><span>${esc(h.fecha)} · ${esc(h.texto)}</span><b class="${h.puntos < 0 ? 'is-menos' : ''}">${h.puntos > 0 ? '+' : ''}${miles(h.puntos)}</b></div>`).join('')}</div>` : ''}`;
  }

  // ── Landing pública (todo de las reglas del ERP) ──
  function landing(el) {
    if (!R) { el.hidden = true; return; }
    const g = R.ganar || {}, ns = niveles(), rs = recompensas(), pm = porMonto();
    // FUSFIT Day = el 13 de noviembre de cada año (dueño, 23-oct): el bloque solo sale ese día, cuando el evento está vigente.
    const fd = C.multEvento(Date.now(), R.eventos).fusfitDay ? (R.eventos || []).find((e) => e.tipo === 'dia_mes' && e.dia === 13) : null;
    const cta = D.sesion
      ? `<a class="ff-pts__btn" href="#ff-mis-puntos">Ver y canjear mis puntos (${miles(saldo())})</a>`
      : `${Number(g.registro) > 0 ? `<a class="ff-pts__btn" href="${esc(D.urls.registro)}">Crear mi cuenta y ganar ${miles(g.registro)}</a>` : ''}<a class="ff-pts__btn ff-pts__btn--sec" href="${esc(D.urls.entrar)}">Iniciar sesión</a>`;
    const tj = (cifra, txt) => `<div class="ff-pts-l__tj"><b>${cifra}</b><span>${txt}</span></div>`;
    el.innerHTML = `
      <div class="ff-pts-l__heroe"><div class="ff-pts-l__env">
        <h1 class="ff-pts-l__h1">FUSFIT <b>POINTS</b></h1>
        <p class="ff-pts-l__lema">Cada compra suma. <b>El límite lo pones tú.</b></p>
        <p>Gana puntos en fusfit.com, por WhatsApp, en la tienda y con Cashea, y cámbialos por descuentos.</p>
        <div class="ff-pts-l__ctas">${cta}</div>
      </div></div>
      <div class="ff-pts-l__env">
        <section><h2 class="ff-pts-h">Cómo ganas</h2><div class="ff-pts-l__rej">
          ${Number(g.compra) > 0 ? tj(`${miles(g.compra)} por $1`, 'En cada compra, por cualquier canal.') : ''}
          ${Number(g.cumpleanos) > 0 ? tj(`+${miles(g.cumpleanos)}`, 'El día de tu cumpleaños.') : ''}
          ${Number(g.recomendar) > 0 ? tj(`+${miles(g.recomendar)}`, `Cuando un amigo que recomendaste hace su primera compra.${R.recomendadoPct ? ` Él tiene ${esc(R.recomendadoPct)} %.` : ''}`) : ''}
          ${Number(g.registro) > 0 ? tj(`+${miles(g.registro)}`, 'Al crear tu cuenta.') : ''}
        </div></section>
      </div>
      ${fd || pm ? `<section class="ff-pts-l__dia"><div class="ff-pts-l__env">
        ${fd ? `<h2 class="ff-pts-h">FUSFIT Day ×${esc(fd.multiplicador)}</h2><p>Hoy es FUSFIT Day: tus compras suman ×${esc(fd.multiplicador)} puntos.</p>` : ''}
        ${pm ? `<p><b>Compras desde ${esc(dolares(pm.desde))}: ×${esc(1 + pm.extra)} ${fd ? ` cualquier día, ×${esc(fd.multiplicador + pm.extra)} hoy` : ' cualquier día'}.</b></p>` : ''}
      </div></section>` : ''}
      <div class="ff-pts-l__env">
        ${rs.length ? `<section><h2 class="ff-pts-h">Cómo canjeas</h2><div class="ff-pts-l__rej">${rs.map((r) => tj(miles(r.costo), esc(r.nombre))).join('')}</div>
          <p>Canjeas en el carrito, en tu cuenta o por WhatsApp. Te damos un código de un solo uso. <b>Tus puntos no se pierden.</b></p></section>` : ''}
        ${ns.length ? `<section><h2 class="ff-pts-h">Niveles</h2><div class="ff-pts-l__tabla"><table><thead><tr><th>Nivel</th><th>Desde</th></tr></thead><tbody>
          ${ns.map((n) => `<tr><td>${esc(n.nombre)}</td><td>${miles(n.desde)} puntos ganados</td></tr>`).join('')}</tbody></table></div>
          <p class="ff-pts__sub">Al subir de nivel te damos premios de bienvenida. Canjear no te baja de nivel.</p></section>` : ''}
        <section><h2 class="ff-pts-h">Preguntas</h2>
          <details class="ff-pts-l__faq"><summary>¿Necesito cuenta?</summary><p>No para ganar: te reconocemos por tu teléfono o tu correo. Sí para ver y canjear en la web.</p></details>
          <details class="ff-pts-l__faq"><summary>¿Cuándo llegan mis puntos?</summary><p>Cuando el pago de tu pedido se confirma.</p></details>
          <details class="ff-pts-l__faq"><summary>¿Mis puntos se pierden?</summary><p>No. Tus puntos no se pierden.</p></details>
          <details class="ff-pts-l__faq"><summary>¿Cómo canjeo?</summary><p>En el carrito tocas «Usar», en tu cuenta tocas «Canjear» o lo pides por WhatsApp. El código es de un solo uso.</p></details>
        </section>
      </div>`;
  }

  // ── Montaje: cada sitio se pinta una vez; el tema re-pinta precio y resumen, y se vuelven a pintar los nuevos ──
  const PINTORES = { ficha, cabecera, carrito, 'mis-puntos': misPuntos, landing };
  function pintarTodo() {
    document.querySelectorAll('[data-ff-pts]:not([data-ff-pts-hecho])').forEach((el) => {
      const f = PINTORES[el.dataset.ffPts]; if (!f) return;
      // Una sola ficha por página (la primera, la del producto principal).
      if (el.dataset.ffPts === 'ficha' && document.querySelector('[data-ff-pts="ficha"]') !== el) { el.hidden = true; el.setAttribute('data-ff-pts-hecho', ''); return; }
      el.setAttribute('data-ff-pts-hecho', '');
      try { f(el); } catch (e) { el.hidden = true; }
    });
  }

  function mensaje(cerca, txt, ok) {
    const m = cerca.closest('[data-ff-pts]')?.querySelector('.ff-pts__msg') || cerca.parentElement.querySelector('.ff-pts__msg');
    if (!m) return;
    m.hidden = false; m.className = 'ff-pts__msg' + (ok ? ' is-ok' : ' is-error'); m.innerHTML = txt;
  }
  async function copiar(txt) { try { await navigator.clipboard.writeText(txt); return true; } catch (_) { return false; } }

  document.addEventListener('click', async (ev) => {
    const pastilla = ev.target.closest('.ff-pts-cab__pastilla');
    if (pastilla) { ev.preventDefault(); alternarPanel(); return; }
    if (!ev.target.closest('.ff-pts-cab, .ff-pts-cab__panel')) alternarPanel(false);

    const bc = ev.target.closest('[data-ff-pts-canjear]');
    if (bc) {
      ev.preventDefault();
      if (bc.disabled) return;
      const txt = bc.textContent; bc.disabled = true; bc.textContent = 'Canjeando…';
      try {
        const j = await canjear(Number(bc.dataset.ffPtsCanjear));
        const enCarrito = bc.closest('[data-ff-pts="carrito"]');
        if (window.ffPuntosAplicar) await window.ffPuntosAplicar(j.codigo).catch(() => null);
        mensaje(bc, `Listo. Tu código es <b>${esc(j.codigo)}</b>${enCarrito ? ' y ya quedó en tu carrito.' : '. Cópialo o úsalo en tu carrito.'}`, true);
        bc.textContent = 'Canjeado';
        if (enCarrito) setTimeout(() => location.reload(), 1200);
      } catch (e) {
        mensaje(bc, esc(e.message || 'No se pudo canjear.'), false);
        bc.disabled = false; bc.textContent = txt;
      }
      return;
    }
    const cp = ev.target.closest('[data-ff-pts-copiar]');
    if (cp) { ev.preventDefault(); const t = cp.textContent; cp.textContent = (await copiar(cp.dataset.ffPtsCopiar)) ? 'Copiado' : 'Mantén presionado para copiar'; setTimeout(() => { cp.textContent = t; }, 1800); }
  });
  document.addEventListener('keydown', (ev) => { if (ev.key === 'Escape') alternarPanel(false); });
  document.addEventListener('submit', async (ev) => {
    const f = ev.target.closest('[data-ff-pts-cumple]'); if (!f) return;
    ev.preventDefault();
    const b = f.querySelector('button'); b.disabled = true;
    try {
      const r = await fetch(PROXY + '?accion=cumpleanos', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ fecha: f.fecha.value }) });
      const j = await r.json().catch(() => null);
      if (j && j.ok && j.activo !== false) { mensaje(b, '¡Listo! Guardamos tu cumpleaños.', true); f.querySelector('input').disabled = true; return; }
      mensaje(b, esc((j && j.error) || 'No se pudo guardar. Inténtalo de nuevo.'), false); b.disabled = false;
    } catch (_) { mensaje(b, 'No se pudo guardar. Inténtalo de nuevo.', false); b.disabled = false; }
  });

  new MutationObserver(pintarTodo).observe(document.body, { childList: true, subtree: true });
  pintarTodo();
  window.ffPuntos = { pintarTodo, estimar };
})();
